var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-page"},[_vm._v("欢迎使用"+_vm._s(_vm.systemName))])
}
var staticRenderFns = []

export { render, staticRenderFns }